import { useMutation, useQueryClient } from "react-query";
import { toast } from 'react-toastify';
import { SrxApi } from '../api/SrxApi';

const useCreateReleaseNote = (setIsModalOpen) => {
  const queryClient = useQueryClient();

  const { mutate: addReleaseNote, isLoading } = useMutation(
    async ({ payload }) => {
      const response = await SrxApi.post(`/versions/release-notes/create-or-edit`, payload);
      return response?.data;
    },
    {
      onSuccess: (data) => {
        if (data) {
          setIsModalOpen(false);
          toast.success(data?.message || "Release note added successfully!");
          queryClient.invalidateQueries(["getAllReleaseNote"]);
          queryClient.invalidateQueries(["currentVersion"]);
        }
      },
      onError: (error) => {
        const errorMessage = error?.response?.data?.message || error?.message || "Failed to add release note";
        toast.error(errorMessage);
      },
    }
  );

  return { addReleaseNote, isAddReleaseNoteLoading: isLoading };
};

export default useCreateReleaseNote;